import { Timestamp } from 'firebase/firestore';
import { t } from 'i18next';

import { LanguageUtils } from '@anyx/shared-utils';


type NotificationLanguages = Record<
  string,
  {
    title: string;
    body: string;
  }
>;
export class NotificationsUtils {
  static readonly getNotificationLanguage = (languages: NotificationLanguages) => {
    const currentLang = LanguageUtils.getCurrentLanguage();
    const language = languages[currentLang] ? currentLang : LanguageUtils.DEFAULT;
    return {
      title:
        languages[language]?.title ||
        t('core.page.notifications.missingContent.title', { ns: 'core' }),
      body:
        languages[language]?.body ||
        t('core.page.notifications.missingContent.body', { ns: 'core' }),
    };
  };
  static readonly getNotificationDate = (timestamp: Timestamp) => {
    return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1e6);
  };
}
